import { Binding } from './type'
import store from '@/store'

function checkPermission (el: Element, binding: Binding) {
  const isSub = store.getters.isSub
  if (isSub) {
    el.parentNode && el.parentNode.removeChild(el)
    // const { value } = binding
  }
}

export default {
  mounted (el: Element, binding: any): void {
    checkPermission(el, binding)
  },
  update (el: Element, binding: any): void {
    checkPermission(el, binding)
  }
}
